module.exports = __webpack_public_path__ + "img/luntan_2018_01.2262242d.jpg";